module.exports = __webpack_public_path__ + "static/media/delet.c3213447.svg";